var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.flex,style:(("flex:" + _vm.grow + " " + _vm.shrink + " " + _vm.breakpoint))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }